"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('widgets/shared/identity/recoveryCodeValidation/recoveryCodeValidation',["require", "exports", "text!./recoveryCodeValidation.html", "knockout", "services/authenticationService", "scriptLoaders/bundleLoader", "models/userIdentityModel", "store/tokenStore", "helpers/accessTokenHelper", "context"], function (require, exports, templateMarkup, ko, authenticationService, bundleLoader, userIdentityModel, tokenStore, accessTokenHelper, context) {
    "use strict";
    /// <amd-dependency path='text!./recoveryCodeValidation.html' name='templateMarkup' />

    var RecoveryCodeValidation = function () {
        function RecoveryCodeValidation() {
            _classCallCheck(this, RecoveryCodeValidation);

            this.checkingCredentials = ko.observable(false);
            this.gettingClaims = ko.observable(false);
            this.message = ko.observable('');
            this.messageVisible = ko.observable(false);
            this.code = ko.observable('');
            this.rememberMe = ko.observable(true);
            this.useRecoveryCode = userIdentityModel.useRecoveryCode;
            this.codeMissing = ko.observable(false);
            this.errorMessageTimeout = null;
            this.code.subscribe(function (code) {
                if (code.indexOf(' ') >= 0) {
                    this.code(code.replace(/\s+/g, ''));
                } else {
                    if (code) {
                        this.codeMissing(false);
                    } else {
                        this.codeMissing(true);
                    }
                    if (code.length === 11) {
                        this.validate();
                    }
                }
            }.bind(this));
        }

        _createClass(RecoveryCodeValidation, [{
            key: "validate",
            value: function validate() {
                var _this = this;

                if (this.code()) {
                    this.checkingCredentials(true);
                    authenticationService.recoveryCode(userIdentityModel.userName(), this.code(), this.rememberMe()).fail(function (loginResponse) {
                        _this.checkingCredentials(false);
                        _this.gettingClaims(false);
                        _this.showErrorMessage(loginResponse.responseText);
                    }).done(function (loginResponse) {
                        if (loginResponse !== null) {
                            userIdentityModel.clear();
                            if (loginResponse.token) {
                                _this.gettingClaims(true);
                                tokenStore.setAccessToken(loginResponse.token.accessToken, loginResponse.token.refreshToken, loginResponse.token.accessTokenExpiresIn);
                                accessTokenHelper.setRefreshTimeout();
                                authenticationService.getManageInfo().done(function (manageInfoResponse) {
                                    context.hereMapsApiKey = manageInfoResponse.hereMapsApiKey;
                                    context.appBundleUrl = manageInfoResponse.appBundleUrl;
                                    bundleLoader.loadBundleAsyncOnce().done(function () {
                                        require(['app/startup'], function () {
                                            userIdentityModel.useRecoveryCode(false);
                                            userIdentityModel.setSessionId(manageInfoResponse.sessionId);
                                            userIdentityModel.claims(manageInfoResponse.claims);
                                            userIdentityModel.setUserName(manageInfoResponse.email);
                                            userIdentityModel.setLocalLoginProvider(manageInfoResponse.localLoginProvider);
                                            userIdentityModel.setInsurerId();
                                            userIdentityModel.isAuthenticated(true);
                                            userIdentityModel.requiresTwoFactor(false);
                                            _this.checkingCredentials(false);
                                            _this.gettingClaims(false);
                                        });
                                    });
                                }).fail(function (err) {
                                    userIdentityModel.isAuthenticated(false);
                                    _this.checkingCredentials(false);
                                    _this.gettingClaims(false);
                                });
                            }
                        }
                    });
                } else {
                    this.codeMissing(this.code() === '');
                    this.showErrorMessage('Validation failed');
                }
            }
        }, {
            key: "showErrorMessage",
            value: function showErrorMessage(error) {
                this.message(error);
                this.resetAnimation();
                this.messageVisible(true);
                this.errorMessageTimeout = setTimeout(function () {
                    this.messageVisible(false);
                }.bind(this), 6000);
                this.errorMessageTimeout = setTimeout(function () {
                    this.messageVisible(false);
                }.bind(this), 6000);
            }
        }, {
            key: "resetAnimation",
            value: function resetAnimation() {
                var $loginForm = $('.login-form')[0];
                $loginForm.style.animation = 'none';
                $loginForm.focus(); /* trigger reflow */
                $loginForm.style.animation = null;
            }
        }]);

        return RecoveryCodeValidation;
    }();

    return { viewModel: RecoveryCodeValidation, template: templateMarkup };
});
//# sourceMappingURL=recoveryCodeValidation.js.map;
